import { Component, OnDestroy, Inject, OnInit } from '@angular/core';
import {
  SuiModal,
  SuiModalService,
  ComponentModalConfig,
  ModalSize,
  DatepickerMode,
} from '@richardlt/ng2-semantic-ui';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';
import { AppFilter, ConfirmModal, CommonServices } from 'src/modules/shared';
import { CompanyService, OrganizationService } from '../../services';
// import { OptionService } from 'src/modules/features/setting/services';
import { YearRecordModal } from '../year-record-modal/year-record-modal.component';
interface INewEquipmentModalContext {
  data: any;
  title?: string;
  isEdit?: boolean;
}
@Component({
  selector: 'app-new-equipment-modal',
  templateUrl: './new-equipment-modal.component.html',
  styleUrls: ['./new-equipment-modal.component.scss'],
})
export class NewEquipmentModalComponent implements OnInit, OnDestroy {
  searchable: boolean = true;
  public mode: DatepickerMode = 'year';
  public maxDate = new Date();
  private unsubscribe$: Subject<void> = new Subject<void>();
  formSubmitAttempt: boolean;
  success: any;
  error: any;
  pending: boolean;

  companyEquipmentForm: FormGroup;
  companyEquipment: any;
  currentForm: FormGroup;
  equipmentTypes: Array<any> = [];
  organizationId: string;
  changeRequestId: any;
  constructor(
    private companySvc: CompanyService,
    private organizationSvc: OrganizationService,
    private modalService: SuiModalService,
    @Inject(DOCUMENT) private document,
    private fb: FormBuilder,
    public modal: SuiModal<INewEquipmentModalContext, void, void>,
    private commonSvc: CommonServices
  ) {
    this.equipmentTypes = modal.context.data['equipmentTypes'];
    this.organizationId = window.localStorage.getItem('organizationId');
    this.companyEquipmentForm = fb.group({
      equipModelNumber: ['', Validators.required],
      equipName: ['', Validators.required],
      yearOfManufacture: ['', Validators.required],
      equipTypeId: ['', Validators.required],
      organizationId: [''],
    });
    // manufacturerName: [''],

    if (modal.context.isEdit) {
      this.companyEquipment = modal.context.data['equipment'];
      this.companyEquipmentForm.patchValue(modal.context.data['equipment']);
      let year = new Date();
      year.setFullYear(modal.context.data['equipment']['yearOfManufacture']);
      this.companyEquipmentForm
        .get('yearOfManufacture')
        .patchValue(new Date(year));
    }
    this.currentForm = this.companyEquipmentForm;
  }

  getEquipmentTypes() {
    let searchFilter = {
      groupOp: 'AND',
      rules: [
        {
          field: 'optionType.optionTypeId',
          op: 'eq',
          data: 'equipment_type',
        },
      ],
    };
    let filter = new AppFilter({ sidx: 'optionId', rows: 10000 });
    filter.filters = JSON.stringify(searchFilter);
    this.commonSvc.getOption({ params: filter }).subscribe((res: any) => {
      this.equipmentTypes = res.rows;
    });
  }

  isFieldValid(field: string) {
    return (
      (!this.companyEquipmentForm.get(field).valid &&
        this.companyEquipmentForm.get(field).touched) ||
      (this.companyEquipmentForm.get(field).untouched && this.formSubmitAttempt)
    );
  }

  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }

  displayFormCss(field: string) {
    return {
      loading: field,
    };
  }
  submit() {
    this.modal.context.isEdit == true ? this.update() : this.save();
  }

  save() {
    this.formSubmitAttempt = false;
    if (this.companyEquipmentForm.valid) {
      this.pending = true;
      let payload = this.companyEquipmentForm.value;
      payload['yearOfManufacture'] =
        this.companyEquipmentForm.value.yearOfManufacture.getFullYear();
      payload['organizationId'] = this.organizationId;
      this.companySvc
        .addCompanyEquipment({
          organizationId: this.organizationId,
          body: payload,
        })
        .subscribe(
          (res) => {
            this.pending = false;
            this.success = 'Company equipment added successfully';
            setTimeout(() => {
              this.modal.approve(null);
            }, 2000);
          },
          (error) => {
            this.pending = false;
            this.error = error.error.errorMessage
              ? error.error.errorMessage
              : error.error
              ? error.error
              : error;
          }
        );
    } else {
      this.formSubmitAttempt = true;
    }
  }

  update() {
    this.formSubmitAttempt = false;
    if (this.companyEquipmentForm.valid) {
      let organizationId = window.localStorage.getItem('organizationId');
      this.pending = true;
      let payload = this.companyEquipmentForm.value;
      console.log(this.companyEquipment.organizationEquipmentId, 'new');
      payload['yearOfManufacture'] =
        this.companyEquipmentForm.value.yearOfManufacture.getFullYear();
      this.companySvc
        .updateCompanyEquipment({
          organizationId: organizationId,
          id: this.companyEquipment.organizationEquipmentId,
          body: {
            ...this.companyEquipment,
            ...this.companyEquipmentForm.value,
          },
        })
        .subscribe(
          (res) => {
            this.pending = false;
            this.success = 'Company equipment updated successfully';
            setTimeout(() => {
              this.modal.approve(null);
            }, 2000);
          },
          (error) => {
            this.pending = false;
            this.error = error.error.errorMessage
              ? error.error.errorMessage
              : error.error
              ? error.error
              : error;
          }
        );
    } else {
      this.formSubmitAttempt = true;
    }
  }

  updateForm() {
    let organizationId = window.localStorage.getItem('organizationId');
    this.formSubmitAttempt = false;
    if (this.companyEquipmentForm.valid) {
      this.pending = true;

      this.companyEquipmentForm.value['yearOfManufacture'] =
        this.companyEquipmentForm.value.yearOfManufacture.getFullYear();

      this.nullify();
      let payload = {
        organization: {
          organizationId: organizationId,
        },
        changeRequestType: 'EQUIPMENT',
        actionType: this.modal.context.isEdit ? 'UPDATE' : 'ADD',
        fromValue: JSON.stringify(this.currentForm.value),
        toValue: JSON.stringify(this.companyEquipmentForm.value),
      };
      this.organizationSvc
        .addChangeRequest({
          organizationId: organizationId,
          body: payload,
        })
        .subscribe(
          (res) => {
            this.pending = false;
            this.success =
              'Equipment List updated successfully. You will be notified when your request has been verified.';
            setTimeout(() => {
              this.modal.approve();
            }, 2000);
          },
          (error) => {
            this.pending = false;
            this.error = error.error.errorMessage
              ? error.error.errorMessage
              : error.error
              ? error.error
              : error;
          }
        );
    } else {
      this.formSubmitAttempt = true;
    }
  }

  nullify() {
    this.success = null;
    this.error = null;
  }
  ngOnInit() {
    // this.document.body.classList.remove('panel');
  }
  // s
  ngOnDestroy(): void {
    // this.document.body.classList.add('panel');
  }

  yearRecord() {
    this.modalService
      .open(
        new YearRecordModal(
          'Year Records',
          'Are you sure you want to delete this Lot plan?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {})
      .onDeny(() => {});
  }
}

export class NewEquipmentModal extends ComponentModalConfig<
  INewEquipmentModalContext,
  void,
  void
> {
  constructor(
    title: string,
    data: any,
    isEdit: boolean,
    size: ModalSize = ModalSize.Mini
  ) {
    super(NewEquipmentModalComponent, { title, data, isEdit });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
